<div class="modus-layout">
  <nav
    class="navbar navbar-blue navbar-expand-sm modus-header border-primary pl-1"
    id="modus-header"
  >
    <modus-app-branding
      [logoPath]="'../assets/img/PCMILER_Logo_BW.svg'"
      [isClickable]="false"
    ></modus-app-branding>
  </nav>
  <div class="modus-body">
    <div class="modus-content-rows">
      <div class="modus-content-columns">
        <div class="modus-content">
          <div class="container-fluid signupHeight pt-2">
            <app-modal-alert class="fixedPageAlert"></app-modal-alert>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb mb-0 pt-2 pl-0">
                <li
                  class="breadcrumb-item active"
                  aria-current="page"
                  *ngIf="!showForm"
                >
                  <a routerLink="/login"> Back</a>
                </li>
                <li class="breadcrumb-item" *ngIf="showForm">
                  <a routerLink="/signup" (click)="navigateFeaturePage()"
                    >Feature
                  </a>
                </li>
              </ol>
            </nav>

            <div class="brand-logo px-4 position-absolute">
              <img
                src="../../assets/img/trimble-maps-logo.svg"
                width="250"
                class="img-fluid ml-1 my-3"
                alt=""
              />
            </div>

            <mat-stepper
              *ngIf="isStepperVisible"
              [linear]="true"
              headerPosition="top"
              labelPosition="bottom"
              (selectionChange)="setIndex($event)"
              #stepper
              class="{{
                'selectedIndex-' + stepper.selectedIndex
              }} background-none h-100"
            >
              <form [formGroup]="signUpForm" class="h-100">
                <mat-step completed="false" editable="true">
                  <ng-template matStepLabel>SIGNUP</ng-template>
                  <app-feature
                    [displayCurrency]="displayCurrency"
                    (featureLevel)="showForms($event)"
                    *ngIf="!showForm"
                  ></app-feature>
                  <app-check-email
                    [parentForm]="signUpForm"
                    *ngIf="showForm"
                  ></app-check-email>
                </mat-step>
                <mat-step editable="true" completed="false">
                  <ng-template matStepLabel>ACCOUNT</ng-template>
                  <app-account-information
                    (completeForm)="nextStep($event)"
                    [parentForm]="signUpForm"
                  ></app-account-information>
                </mat-step>
                <mat-step editable="true" completed="false">
                  <ng-template matStepLabel>BILLING</ng-template>
                  <app-billing-signup
                    [displayCurrency]="displayCurrency"
                    (completeForm)="nextStep($event)"
                    [parentForm]="signUpForm"
                  ></app-billing-signup>
                  <div></div>
                </mat-step>
                <mat-step editable="true" completed="false">
                  <ng-template matStepLabel>REVIEW</ng-template>
                  <app-review-signup
                    [displayCurrency]="displayCurrency"
                    (completeSubmit)="submit($event)"
                    [parentForm]="signUpForm"
                  ></app-review-signup>

                  <div></div>
                </mat-step>
              </form>
              <!-- Icon overrides. -->
              <ng-template matStepperIcon="number">
                <i class="modus-icons icon-size">circle</i>
              </ng-template>
              <ng-template matStepperIcon="edit">
                <i class="modus-icons icon-size">circle_dot</i>
              </ng-template>
              <ng-template matStepperIcon="selected">
                <i class="modus-icons icon-size">circle_dot</i>
              </ng-template>
              <ng-template matStepperIcon="active">
                <i class="modus-icons icon-size">circle_dot</i>
              </ng-template>
              <ng-template matStepperIcon="done">
                <i class="modus-icons icon-size">check_circle</i>
              </ng-template>
            </mat-stepper>
            <div class="background-none" *ngIf="!isStepperVisible">
              <div class="card shadow confirmation-card m-4 w-75">
                <div class="card-body ConfirmationMessage py-5">
                  <div class="col d-flex">
                    <div class="w-75">
                      <div class="d-flex flex-row justify-content-between">
                        <h1 class="card-title" id="card-title">
                          Thank you for purchasing PC*MILER
                        </h1>
                      </div>
                      <div class="d-flex flex-row">
                        <div
                          class="d-flex flex-row flex-fill justify-content-between"
                        >
                          <div class="">
                            <p>
                              A Confirmation has been sent to the email address
                              you provided.
                            </p>
                            <p>
                              Please<a
                                (click)="redirectToLogin()"
                                routerLink="/login"
                              >
                                click here </a
                              >to login
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
